module.exports = __webpack_public_path__ + "img/papelera.ddfe7205.png";